import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import {
  ComplianceApi,
  type IParamsGenerate10DLCAIMessage,
  type IParamsGenerate10DLCAIDesc,
} from 'entities/Compliance'
import type { ComplianceLayerStore } from './complianceLayerStore'

export class AiGenerationStore {
  constructor(private _complianceLayerStore: ComplianceLayerStore) {
    makeAutoObservable(this)
  }

  private _descLoading = false
  private _messageLoading = false
  private _message2Loading = false

  private _istDescGenerated = false
  private _isMessageGenerated = false
  private _isMessage2Generated = false

  get descLoading() {
    return this._descLoading
  }

  get messageLoading() {
    return this._messageLoading
  }

  get message2Loading() {
    return this._message2Loading
  }

  get istDescGenerated() {
    return this._istDescGenerated
  }

  get isMessageGenerated() {
    return this._isMessageGenerated
  }

  get isMessage2Generated() {
    return this._isMessage2Generated
  }

  get complianceLayerStore() {
    return this._complianceLayerStore
  }

  generateTollFreeAIDesc = async () => {
    const { businessInformation } = this.complianceLayerStore

    try {
      this._descLoading = true

      const { data } = await ComplianceApi.generateTollFreeAIDesc({
        company_name: businessInformation?.business_name || '',
        website: businessInformation?.website_url || '',
      })

      return data
    } catch (error) {
      logger.error(error)
    } finally {
      this._descLoading = false
      this._istDescGenerated = true
    }
  }

  generate10DLCAIDesc = async (descriptionData: IParamsGenerate10DLCAIDesc) => {
    try {
      this._descLoading = true

      const { data } = await ComplianceApi.generate10DLCAIDesc(descriptionData)

      return data
    } catch (error) {
      logger.error(error)
    } finally {
      this._descLoading = false
      this._istDescGenerated = true
    }
  }

  generate10DLCAIMessage = async (messageData: IParamsGenerate10DLCAIMessage) => {
    try {
      const { data } = await ComplianceApi.generate10DLCAIMessages(messageData)

      return data
    } catch (error) {
      logger.error(error)
    }
  }

  generateTollFreeAIMessage = async ({
    useCaseDesc,
    useCaseValue,
  }: {
    useCaseDesc: string
    useCaseValue: string
  }) => {
    const { businessInformation, complianceServiceCampaign } = this.complianceLayerStore

    try {
      this._messageLoading = true

      const { data } = await ComplianceApi.generateTollFreeAIMessage({
        company_name: businessInformation?.business_name || '',
        description: useCaseDesc.length
          ? useCaseDesc
          : complianceServiceCampaign?.data?.useCaseData?.description || '',
        use_case: useCaseValue.length
          ? useCaseValue
          : complianceServiceCampaign?.data?.useCaseData?.useCaseTitle || '',
        website: businessInformation?.website_url || '',
      })

      return data
    } catch (error) {
      logger.error(error)
    } finally {
      this._messageLoading = false
      this._isMessageGenerated = true
    }
  }

  resetMessage1GenerationFlag = () => {
    this._isMessageGenerated = false
  }

  resetMessage2GenerationFlag = () => {
    this._isMessage2Generated = false
  }
}
